import axios from "../instance";

export default {
  getAll: () => {
    return axios.api.get("/mSubDistricts").then((response) => response.data);
  },
  getOne: (id) => {
    return axios.api
      .get(`/mSubDistricts/${id}`)
      .then((response) => response.data);
  },
  search: (body) => {
    return axios.api
      .post("/mSubDistricts/search", body)
      .then((response) => response.data);
  },
  create: (body) => {
    return axios.api
      .post("/mSubDistricts", body)
      .then((response) => response.data);
  },
  update: (id, body) => {
    return axios.api
      .put(`/mSubDistricts/${id}`, body)
      .then((response) => response.data);
  },
  delete: (id) => {
    return axios.api
      .delete(`/mSubDistricts/${id}`)
      .then((response) => response.data);
  },
};
